export const GENERAL_PRODUCTLIST_SET = "GENERAL_PRODUCTLIST_SET";
